import { LuChevronRight } from 'react-icons/lu';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from './common/BreadCrumbs';
import { useThemeStore } from '../state/theme';

const InvoiceBreadCrumbs: React.FC<{ agentName: string }> = ({ agentName }) => {
  const { isDarkMode } = useThemeStore();

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem
          className={`text-lg underline ${isDarkMode ? 'text-indigo-500' : 'text-blue-500'}`}
        >
          <BreadcrumbLink href="/agents">Agents</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator>
          <LuChevronRight
            className={`w-8 h-8 ${isDarkMode ? 'text-white' : 'text-black'}`}
          />
        </BreadcrumbSeparator>
        <BreadcrumbItem
          className={`text-lg ${isDarkMode ? 'text-white' : 'text-black'}`}
        >
          <BreadcrumbLink>{agentName}</BreadcrumbLink>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default InvoiceBreadCrumbs;
